import { Link } from "react-router-dom";
import { SITE, SERVICES } from "../data/site";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="wrap footer-grid">
        <div>
          <h2>CCS</h2>
          <p>{SITE.tagline}</p>
          <p style={{ marginTop: "1rem" }}>
            {SITE.owner}
            <br />
            {SITE.addresses[0].street}
            <br />
            {SITE.addresses[0].zip} {SITE.addresses[0].city}
          </p>
        </div>
        <div>
          <h3>Leistungen</h3>
          <div className="footer-links" style={{ marginTop: "0.8rem" }}>
            {SERVICES.map((s) => (
              <Link key={s.slug} to={`/leistungen/${s.slug}`}>
                {s.title}
              </Link>
            ))}
            <Link to="/reinigung">Reinigung</Link>
          </div>
        </div>
        <div>
          <h3>Kontakt</h3>
          <div className="footer-links" style={{ marginTop: "0.8rem" }}>
            <a href={`tel:${SITE.phoneTel}`}>{SITE.phoneDisplay}</a>
            <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
            <Link to="/kontakt">Anfahrt & Anfrage</Link>
          </div>
        </div>
      </div>
      <div className="wrap footer-bottom">
        <span>© {new Date().getFullYear()} {SITE.name}</span>
        <Link to="/impressum">Impressum</Link>
        <Link to="/datenschutz">Datenschutz</Link>
      </div>
    </footer>
  );
}
